import { getMadinaCategories } from 'network/services/madina';

export const normalizeCatalogLabel = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const resolveMadinaSubcategoryId = async (
  subCategoryName: string,
  parentCategoryId?: number
): Promise<number | undefined> => {
  const needle = normalizeCatalogLabel(decodeURIComponent(subCategoryName));
  if (!needle) return undefined;

  const categories = await getMadinaCategories();
  const scoped = parentCategoryId
    ? categories.filter(category => category.id === Number(parentCategoryId))
    : categories;

  for (const category of scoped) {
    for (const sub of category.subcategories ?? []) {
      if (normalizeCatalogLabel(sub.name) === needle) {
        return sub.id;
      }
    }
  }

  for (const category of scoped) {
    for (const sub of category.subcategories ?? []) {
      const hay = normalizeCatalogLabel(sub.name);
      if (hay.includes(needle) || needle.includes(hay)) {
        return sub.id;
      }
    }
  }

  return undefined;
};

export const madinaProductMatchesSubcategoryLabel = (
  subCategoryName: string,
  productSubcategoryName?: string | null
): boolean => {
  const needle = normalizeCatalogLabel(decodeURIComponent(subCategoryName));
  const hay = normalizeCatalogLabel(productSubcategoryName ?? '');
  if (!needle || !hay) return false;
  return hay === needle || hay.includes(needle) || needle.includes(hay);
};
